import axios from 'axios';
import Cookies from 'js-cookie';
import { report } from 'src/helper';

export interface Response<T = any> {
  code: number;
  data: T;
  message: string;
}

let citoken = window?.FMC_HOST?.citoken;

const updateCitoken = (nextCitoken: string) => {
  citoken = nextCitoken;
};

const axiosLoader = (injectCitoken: string) => {
  updateCitoken(injectCitoken);

  const AXIOS_CONFIG = {
    baseURL: '/',
    timeout: 10000,
    token: {
      key: 'X-FMC-Commit-Token',
      getValue() {
        return citoken;
      },
    },
    grey: {
      key: 'X-FMC-Grey-Switch',
      getValue() {
        const grey = Cookies.get('fmcgrey');
        if (grey != null) {
          return 1;
        }
        return 0;
      },
    },
    responseType: 'json',
    withCredentials: true, // 是否允许带cookie这些
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
  };

  const axiosInstance = axios.create(AXIOS_CONFIG as any);
  axiosInstance.interceptors.request.use(
    (config) => {
      // 2 若是有做鉴权token , 就给头部带上token
      if (AXIOS_CONFIG.token) {
        (config as any).headers[AXIOS_CONFIG.token.key] = AXIOS_CONFIG.token.getValue();
      }
      if (AXIOS_CONFIG.grey) {
        (config as any).headers[AXIOS_CONFIG.grey.key] = AXIOS_CONFIG.grey.getValue();
      }
      (config as any).startTime = new Date().getTime();
      return config;
    },
    (error) => {
      const { message = '' } = error.data.error;
      // 上报请求
      return Promise.reject(message);
    },
  );

  // 返回状态判断(添加响应拦截器)
  axiosInstance.interceptors.response.use(
    (response) => {
      const { config, data } = response;

      report.api({
        api_name: config.url!,
        http_code: '200',
        api_cost: `${new Date().getTime() - (config as any).startTime}`,
        api_result: data.code === 0 ? '1' : '2', // 1-成功；2-失败
      });

      return data;
    },
    (error: any) => {
      if (error?.response) {
        report.api({
          api_name: error.response.config.url,
          http_code: error.response.status,
          api_cost: `${new Date().getTime() - error.response.config.startTime}`,
          api_result: '2', // 1-成功；2-失败
        });
      }
      return Promise.reject(error);
    },
  );

  return axiosInstance;
};


// 这里不提供请求函数了，请使用helper/Request

export default {
  axiosLoader,
  citoken,
  updateCitoken,
};
